// import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo';

// import ShippingPackagesGql from '@/extensions/shop/store/graphql/queries/ShippingPackages.gql';
import CreateShippingPackageGql from '@/extensions/shop/store/graphql/mutations/CreateShippingPackage.gql';
import UpdateShippingPackageGql from '@/extensions/shop/store/graphql/mutations/UpdateShippingPackage.gql';

export default {
    // fetchList: (shopID = null) =>
    //     new Promise((resolve, reject) => {
    //         let variables = {};
    //         if (shopID) variables.shop = parseInt(shopID);

    //         apolloClient
    //             .query({
    //                 query: ShippingPackagesGql,
    //                 variables,
    //             })
    //             .then(({ data }) => resolve(data.CO_ShippingPackages))
    //             .catch((err) => reject(err));
    //     }),
    // fetchShippingPackagesPaginated: data => new Promise((resolve, reject) => {

    //     let filters = []
    //     _.each(data.filters, entry => filters.push(entry))

    //     apolloClient.query({
    //         query: ShippingPackagesPaginatedGql,
    //         variables: {
    //             currentPage: _.get(data, 'pageInfo.currentPage', 1),
    //             perPage: _.get(data, 'pageInfo.perPage', 25),
    //             order: _.get(data, 'variables.order', 'id'),
    //             direction: _.get(data, 'variables.direction', 'asc'),
    //             filters,
    //         }
    //     })
    //         .then(({data}) => resolve(data))
    //         .catch(err => reject(err))
    // }),
    create: shippingPackage => {
        if (shippingPackage === undefined) throw new Error('required argument is missing')

        shippingPackage = _.removeDeepByKey(shippingPackage, '__typename')
        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: CreateShippingPackageGql,
                variables: { shippingPackage }
            })
                .then(async ({ data }) => {
                    await apolloClient.clearStore()
                    resolve(data.CO_CreateShippingPackage)
                })
                .catch(err => reject(err))
        })
    },
    update: shippingPackage => {
        if (shippingPackage === undefined) throw new Error('required argument is missing')
        shippingPackage = _.removeDeepByKey(shippingPackage, '__typename')

        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: UpdateShippingPackageGql,
                variables: { shippingPackage }
            })
                .then(async ({ data }) => {
                    await apolloClient.clearStore()
                    resolve(data.CO_UpdateShippingPackage)
                })
                .catch(err => reject(err))
        })
    },
    // delete: id => {
    //     if (id === undefined) throw new Error('required argument is missing')

    //     return new Promise((resolve, reject) => {
    //         apolloClient.mutate({
    //             mutation: DeleteShippingPackageGql,
    //             variables: { id }
    //         })
    //             .then(({data}) => {
    //                 apolloClient.clearStore()
    //                 resolve(data.CO_DeleteShippingPackage)
    //             })
    //             .catch(err => reject(err))
    //     })
    // }
};
